module.exports = __webpack_public_path__ + "img/fausto.8d938537.jpg";